<template>
  <IconLucideMessageCircle />
</template>
